import React         from 'react';
import CheckboxInput from '../Fields/CheckboxInput';

const DataProtection = React.createClass({
    propTypes: {
        alternateBackground: React.PropTypes.bool,
        hasBorder: React.PropTypes.bool,
    },

    getDefaultProps() {
        return {
            alternateBackground: false,
            hasBorder: false,
        };
    },

    getInitialState() {
        return {
            isContactMethodsVisible: false
        };
    },

    handleClick(e) {
        e.preventDefault();
        this.setState({ isContactMethodsVisible: true });
    },

    render() {
        return (
            <div className={this.props.alternateBackground === true ? 'alternate-background' : null}>
                {/* <question-row class={this.props.hasBorder === false ? 'no-border' : null}> */}
                <question-row class={this.props.hasBorder === false ? 'unpadded fixed' : null}> 
                    <div className="question-main">
                        <h3>Keeping your information secure</h3>
                        <div className="question-input">
                            <p>We&rsquo;re committed to protecting your privacy. We&rsquo;ll only use the information we collect about you lawfully, in accordance with Data Protection Legislation. If you&rsquo;d like to know more about how we protect your data, please read our <a href="https://homelet.co.uk/privacy-notice"  target="_blank" className="underline">privacy policy</a>.</p>
                            <p><a href="#" className="underline" onClick={this.handleClick}>Please click here to read about how we&rsquo;ll use your information</a></p>
                            { this.state.isContactMethodsVisible ? (
                                <div>
                                    <p>By providing us with your contact details you consent to being contacted by post, email, text and telephone in relation to your quote for landlord insurance. We'd also like to keep in contact with you about offers, products, and services from Barbon and PIB Group companies, which we feel may be relevant to you as a landlord. You can contact us at any time to change your preferences.</p>
                                    <CheckboxInput
                                        fieldName="dpa_phone_post_is_disallowed"
                                        question="If you'd prefer HomeLet do not contact you with any further information by phone or post please tick this box."
                                        loadCachedValue={true}
                                        forcePushLocalStorageValue={true}
                                    />
                                    <CheckboxInput
                                        fieldName="dpa_sms_email_is_disallowed"
                                        question="If you'd prefer HomeLet do not contact you with any further information by email or SMS please tick this box."
                                        loadCachedValue={true}
                                        forcePushLocalStorageValue={true}
                                    />
                                </div>
                            ) : null }
                            <p>We won&rsquo;t pass your information on to any third parties without your consent. Please tick this box if you&rsquo;re happy for HomeLet to share your information with our trusted partners, for offers, information and products that we think might be of interest to you as a landlord.</p>
                            <CheckboxInput
                                fieldName="dpa_resale_is_allowed"
                                question="I am happy for HomeLet to share my information with trusted partners."
                                loadCachedValue={true}
                                forcePushLocalStorageValue={true}
                            />
                        </div>
                    </div>
                </question-row>
            </div>
        );
    }
});

export default DataProtection;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/DataProtection.js
 **/